import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import {ScrollSpy} from "bootstrap/dist/js/bootstrap.esm";

const [w,d,mq] = [window,document,window.matchMedia('(max-width: 901px)')];

class scrollEvent {
  constructor() {
    gsap.registerPlugin( ScrollTrigger );
    this.init();
  }
  init() {
    this.nav();
    this.matrix();
    new ScrollSpy(d.body, {
      target: ".equipment-nav",
    });
  }

  nav () {
    ScrollTrigger.create({
      trigger: '.equipment-nav', //アニメーションが始まるトリガーとなる要素
      start: 'top top',
      end: 'bottom bottom',
      endTrigger: '.equipment-section-wrap',
      pin: true,
      pinSpacing: false,
      // markers: true,
    });
  }

  matrix() {
    ScrollTrigger.create({
      trigger: '.equipment-matrix', //アニメーションが始まるトリガーとなる要素
      start: 'top 75%',
      endTrigger: 'footer',
      toggleClass: {targets: "html", className: "is-light-mode"},
      onToggle: () => {
        d.documentElement.classList.toggle('is-dark-mode')
      }
      // markers: true,
    });
  }
}

export default function EQUIPMENT () {
  d.addEventListener('DOMContentLoaded', () => new scrollEvent );
}